/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as GRouteImport } from './routes/g'
import { Route as KalendarzRouteImport } from './routes/kalendarz'
import { Route as KontoRouteImport } from './routes/konto'
import { Route as TelefonRouteImport } from './routes/telefon'
import { Route as AdminWiedzaRouteImport } from './routes/admin_.wiedza'
import { Route as PodgladIndexRouteImport } from './routes/podglad.index'
import { Route as PodgladIdRouteImport } from './routes/podglad.$id'
import { Route as QSlugRouteImport } from './routes/q.$slug'
import { Route as STokenRouteImport } from './routes/s.$token'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const GRoute = GRouteImport.update({
  id: '/g',
  path: '/g',
  getParentRoute: () => rootRouteImport,
} as any)
const KalendarzRoute = KalendarzRouteImport.update({
  id: '/kalendarz',
  path: '/kalendarz',
  getParentRoute: () => rootRouteImport,
} as any)
const KontoRoute = KontoRouteImport.update({
  id: '/konto',
  path: '/konto',
  getParentRoute: () => rootRouteImport,
} as any)
const TelefonRoute = TelefonRouteImport.update({
  id: '/telefon',
  path: '/telefon',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWiedzaRoute = AdminWiedzaRouteImport.update({
  id: '/admin_/wiedza',
  path: '/admin/wiedza',
  getParentRoute: () => rootRouteImport,
} as any)
const PodgladIndexRoute = PodgladIndexRouteImport.update({
  id: '/podglad/',
  path: '/podglad/',
  getParentRoute: () => rootRouteImport,
} as any)
const PodgladIdRoute = PodgladIdRouteImport.update({
  id: '/podglad/$id',
  path: '/podglad/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const QSlugRoute = QSlugRouteImport.update({
  id: '/q/$slug',
  path: '/q/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/chat': typeof ChatRoute
  '/g': typeof GRoute
  '/kalendarz': typeof KalendarzRoute
  '/konto': typeof KontoRoute
  '/telefon': typeof TelefonRoute
  '/admin/wiedza': typeof AdminWiedzaRoute
  '/podglad/$id': typeof PodgladIdRoute
  '/q/$slug': typeof QSlugRoute
  '/s/$token': typeof STokenRoute
  '/podglad/': typeof PodgladIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/chat': typeof ChatRoute
  '/g': typeof GRoute
  '/kalendarz': typeof KalendarzRoute
  '/konto': typeof KontoRoute
  '/telefon': typeof TelefonRoute
  '/admin/wiedza': typeof AdminWiedzaRoute
  '/podglad/$id': typeof PodgladIdRoute
  '/q/$slug': typeof QSlugRoute
  '/s/$token': typeof STokenRoute
  '/podglad': typeof PodgladIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/chat': typeof ChatRoute
  '/g': typeof GRoute
  '/kalendarz': typeof KalendarzRoute
  '/konto': typeof KontoRoute
  '/telefon': typeof TelefonRoute
  '/admin_/wiedza': typeof AdminWiedzaRoute
  '/podglad/$id': typeof PodgladIdRoute
  '/q/$slug': typeof QSlugRoute
  '/s/$token': typeof STokenRoute
  '/podglad/': typeof PodgladIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/chat'
    | '/g'
    | '/kalendarz'
    | '/konto'
    | '/telefon'
    | '/admin/wiedza'
    | '/podglad/$id'
    | '/q/$slug'
    | '/s/$token'
    | '/podglad/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/chat'
    | '/g'
    | '/kalendarz'
    | '/konto'
    | '/telefon'
    | '/admin/wiedza'
    | '/podglad/$id'
    | '/q/$slug'
    | '/s/$token'
    | '/podglad'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/chat'
    | '/g'
    | '/kalendarz'
    | '/konto'
    | '/telefon'
    | '/admin_/wiedza'
    | '/podglad/$id'
    | '/q/$slug'
    | '/s/$token'
    | '/podglad/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  ChatRoute: typeof ChatRoute
  GRoute: typeof GRoute
  KalendarzRoute: typeof KalendarzRoute
  KontoRoute: typeof KontoRoute
  TelefonRoute: typeof TelefonRoute
  AdminWiedzaRoute: typeof AdminWiedzaRoute
  PodgladIdRoute: typeof PodgladIdRoute
  QSlugRoute: typeof QSlugRoute
  STokenRoute: typeof STokenRoute
  PodgladIndexRoute: typeof PodgladIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/g': {
      id: '/g'
      path: '/g'
      fullPath: '/g'
      preLoaderRoute: typeof GRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kalendarz': {
      id: '/kalendarz'
      path: '/kalendarz'
      fullPath: '/kalendarz'
      preLoaderRoute: typeof KalendarzRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/konto': {
      id: '/konto'
      path: '/konto'
      fullPath: '/konto'
      preLoaderRoute: typeof KontoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telefon': {
      id: '/telefon'
      path: '/telefon'
      fullPath: '/telefon'
      preLoaderRoute: typeof TelefonRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/wiedza': {
      id: '/admin_/wiedza'
      path: '/admin/wiedza'
      fullPath: '/admin/wiedza'
      preLoaderRoute: typeof AdminWiedzaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/podglad/': {
      id: '/podglad/'
      path: '/podglad'
      fullPath: '/podglad/'
      preLoaderRoute: typeof PodgladIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/podglad/$id': {
      id: '/podglad/$id'
      path: '/podglad/$id'
      fullPath: '/podglad/$id'
      preLoaderRoute: typeof PodgladIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/q/$slug': {
      id: '/q/$slug'
      path: '/q/$slug'
      fullPath: '/q/$slug'
      preLoaderRoute: typeof QSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  ChatRoute: ChatRoute,
  GRoute: GRoute,
  KalendarzRoute: KalendarzRoute,
  KontoRoute: KontoRoute,
  TelefonRoute: TelefonRoute,
  AdminWiedzaRoute: AdminWiedzaRoute,
  PodgladIdRoute: PodgladIdRoute,
  QSlugRoute: QSlugRoute,
  STokenRoute: STokenRoute,
  PodgladIndexRoute: PodgladIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
